import React from "react";

import { Icon, Tooltip, Functions } from "rhombus-react";

export default function FramingButton({
	isVisible = false,
	onClick = Functions.noop,
	className = "",
}){
	if(!isVisible){ return null; }

	return (
		<Tooltip description="Adjust Framing" direction="top">
			<Icon className={`bounce-circle cypress-tooltip-button-open-smart-framing-blade ${className}`}
				name="far fa-frame"
				onClick={onClick} />
		</Tooltip>
	);
}

FramingButton.displayName = "FramingButton";
